module.exports = __webpack_public_path__ + "img/img-157.1449c2d1.png";